var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.8 184.9c11.1 41.8-0.9 86.7-31.4 117.3-9.2 9.2-19.7 16.8-31.1 22.6v104.6c0 76.1-48.8 141-116.7 165.2-6.6 9.2-14 18-22 26-5.2 5.2-10.7 10.2-16.4 14.7v166.5c0 10-8.1 18-18 18h-59.7v19.5c0 10-8.1 18-18 18H556c-10 0-18-8.1-18-18V674.1H411.8v127.6c0 10-8.1 18-18 18h-59.7v19.5c0 10-8.1 18-18 18h-86.4c-9.9 0-18-8.1-18-18V638.9c-50.5-35.8-80.4-93.3-80.4-155.6 0-15.2 1.8-30 5.2-44.4-3.4 0.5-6.9 0.8-10.4 0.8-34.5 0-62.6-28.1-62.6-62.6 0-29.6 24.1-53.7 53.7-53.7 5.6 0 11.1 1 16.3 2.9 9.3 3.5 14.1 13.9 10.6 23.2-3.5 9.3-13.9 14.1-23.2 10.6-1.2-0.4-2.5-0.7-3.7-0.7-9.7 0-17.6 7.9-17.6 17.6 0 14.7 11.9 26.6 26.6 26.6 12.5 0 24.1-6.2 31.1-16.5 8.2-14 18.2-27 30-38.8 36.1-36.1 84-55.9 135-55.9h180.6c-24-29.9-32.7-69.9-22.7-107.4 1.7-6.2 6.5-11.1 12.8-12.8 41.8-11.1 86.7 0.9 117.3 31.4 10.1 10.1 18.3 21.9 24.3 34.8 26.9-9.7 54.9-14.6 83.5-14.7 28.6 0.1 56.6 5 83.5 14.7 6-12.9 14.2-24.7 24.3-34.8C856.3 173 901.3 161 943 172.1c6.3 1.7 11.1 6.6 12.8 12.8z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.1 204.9c3.5 26.2-5.3 52.9-24.2 71.8-6.8 6.8-14.5 12.3-22.9 16.4-2.3 1.1-4.7 2.2-7.1 3.1-7 2.6-11.7 9.4-11.7 16.9v116.3c0 76.8-62.4 139.2-139.2 139.2-76.8 0-139.2-62.5-139.2-139.2V313c0-7.5-4.6-14.2-11.6-16.9-11.3-4.3-21.4-10.8-30.1-19.5-18.9-18.9-27.7-45.6-24.2-71.8 26.2-3.5 52.9 5.3 71.8 24.2 10.5 10.5 18 23.5 21.9 37.7 2.6 9.6 12.6 15.3 22.2 12.6 0.9-0.3 1.8-0.6 2.6-1 27.5-12.4 56.7-18.7 86.6-18.7 29.9 0.1 59 6.4 86.6 18.7 0.8 0.4 1.7 0.7 2.6 0.9 9.6 2.6 19.5-3 22.1-12.6 3.9-14.2 11.5-27.2 21.9-37.7 19-18.7 45.7-27.5 71.9-24z",
    fill: "#F9DCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.2 343.6m-17.9 0a17.9 17.9 0 1 0 35.8 0 17.9 17.9 0 1 0-35.8 0Z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 384.4c51 0 92.5 34.4 92.5 76.6S769 537.6 718 537.6s-92.5-34.4-92.5-76.6 41.5-76.6 92.5-76.6z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 416.8c33.1 0 60.1 19.8 60.1 44.2s-26.9 44.2-60.1 44.2c-33.1 0-60.1-19.8-60.1-44.2s27-44.2 60.1-44.2z",
    fill: "#B88D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.9 444.9c8.9 0 16.1 7.2 16.1 16.1 0 8.9-7.2 16.1-16.1 16.1-8.9 0-16.1-7.2-16.1-16.1 0-8.9 7.2-16.1 16.1-16.1z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 604.5h0.6c-22.5 24.8-75.7 37.3-75.7 37.3h-0.6c-10 0-18 8.1-18 18v104.1H574V656.1c0-9.9-8.1-18-18-18H316.1c-5 0-9.5 2-12.7 5.3-3.3 3.3-5.3 7.8-5.3 12.7V764h-50.3V629.3c0-6.3-3.2-11.8-8.2-15.1-0.1-0.1-0.2-0.1-0.2-0.2-45.1-28.6-72-77.5-72-130.8 0-41.4 16.1-80.3 45.3-109.5 29.2-29.2 68.1-45.3 109.5-45.3h220.5v100.9c0 96.6 78.6 175.2 175.3 175.2z",
    fill: "#F9DCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.4 762.4h41.7v21.2h-41.7z",
    fill: "#B88D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 658.6v67.8h-41.7v-52.1c14.6-3.7 28.5-9 41.7-15.7z",
    fill: "#F9DCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689 444.9c8.9 0 16.1 7.2 16.1 16.1 0 8.9-7.2 16.1-16.1 16.1-8.9 0-16.1-7.2-16.1-16.1 0-8.9 7.2-16.1 16.1-16.1z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.8 343.6m-17.9 0a17.9 17.9 0 1 0 35.8 0 17.9 17.9 0 1 0-35.8 0Z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574 800h50.3v21.2H574z",
    fill: "#B88D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.1 375.7c10 0 18 8.1 18 18s-8.1 18-18 18H300.6c-10 0-18-8.1-18-18 0-10 8.1-18 18-18h160.5z",
    fill: "#663333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1 762.4h41.7v21.2h-41.7z",
    fill: "#B88D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1 674.1h41.7v52.2h-41.7z",
    fill: "#F9DCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.8 800h50.3v21.2h-50.3z",
    fill: "#B88D5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPork);
export default __webpack_public_path__ + "static/media/pork.77887c46eae3ca1e7568e35fc9f23bcd.svg";
export { ForwardRef as ReactComponent };